export function BatteryVoltage({ voltage }: { voltage: string }) {
  if (voltage === undefined || voltage === null) return <>-</>;
  return <>{voltage}V</>;
}
